import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const FilterMultiSelectItem = ({
  isMapPage = false,
  isSelected,
  item,
  onSelect,
  inline,
  invert,
}) => {
  const theme = useContext(ThemeContext);
  const pinIconClass = `map-view-pin-icon ${item.value}`;

  return (
    <>
      <li
        aria-selected={isSelected}
        className={classNames('select-item', { selected: isSelected })}
        label={item.name}
        onClick={() => onSelect(item.value)}
        onKeyPress={() => onSelect(item.value)}
        role="option"
        tabIndex={0}
        value={item.value}
      >
        {isMapPage && (
          <div className="map-view-pin">
            <i className={pinIconClass}> </i>
          </div>
        )}
        <FontAwesomeIcon
          color={invert ? '#fff' : theme.colors.primary}
          icon={isSelected ? faCheckCircle : faCircle}
        />
        {item.name}
      </li>
      <style jsx>{`
        .select-item {
          display: flex;
          align-items: center;
          position: relative;
          cursor: pointer;
          margin-top: ${inline ? 4 : 7}px;
          padding-top: ${isMapPage ? 8 : 0}px;
          color: ${invert ? theme.colors.primarypale : '#000'};
        }
        .select-item:hover {
          color: ${invert ? '#fff' : theme.colors.primary};
        }
        .select-item.selected {
          color: ${invert ? '#fff' : theme.colors.filterslider};
        }
        .select-item :global(svg) {
          font-size: 18px;
          margin-right: 12px;
        }
        .map-view-pin {
          margin-right: 10px;
          position: relative;
          transform-origin: 50% 50%;
        }
      `}</style>
    </>
  );
};

FilterMultiSelectItem.propTypes = {
  inline: PropTypes.bool,
  invert: PropTypes.bool,
  isMapPage: PropTypes.bool,
  isSelected: PropTypes.bool,
  item: PropTypes.object,
  onSelect: PropTypes.func,
};

export default FilterMultiSelectItem;
